import { type FieldValues, useController } from 'react-hook-form';
import { FileUploadField } from '../FileUploadField/FileUploadField';
import type {
  FormControlProps,
  TypedUseControllerProps,
} from '../FormControl/FormControl.types';
import type { RadioFieldProps } from '../RadioField/RadioField';

export type FormFileUploadProps<
  TFieldValues extends FieldValues = FieldValues,
> = TypedUseControllerProps<TFieldValues, File | null> &
  FormControlProps<RadioFieldProps> & {
    /** Placeholder shown when no file is selected. Defaults to "Choose…". */
    placeholder?: string;
  };

export const FormFileUpload = <TFieldValues extends FieldValues = FieldValues>({
  disabled,
  ...props
}: FormFileUploadProps<TFieldValues>) => {
  const {
    field: { ref, onChange, ...field },
    formState: { errors },
  } = useController(props);

  const error = errors[props.name]?.message?.toString();

  return (
    <FileUploadField
      {...props}
      {...field}
      disabled={disabled}
      error={error}
      onFileSelected={onChange}
    />
  );
};
